import { CHANNEL_ID, FILE_ID } from '@@types/common';

import { URLS } from '~/constants';
import { converge, head, last, map, merge, objOf, pipe, prop, split } from 'ramda';

const splitMimeTypeAndBytes: (value: string) => { mimeType: string; byteString: string } = pipe<any, any, any>(
  split(','),
  converge(merge, [pipe(head, split(':'), last, split(';'), head, objOf('mimeType')), pipe(last, objOf('byteString'))])
);

export const bytesToUint8Array = pipe<string, string, number[], Uint8Array>(
  atob,
  // @ts-ignore
  map((raw: string, index: number) => raw.charCodeAt(index)),
  (uint8Array) => new Uint8Array(uint8Array)
);

export const convertUint8ArrayToBlob = (uint8Array: Uint8Array, options: { type: string }): Blob => {
  return new Blob([uint8Array], options);
};

export const convertBase64ToBlob: (value: string) => Blob = pipe<any, any, any>(
  splitMimeTypeAndBytes,
  converge(convertUint8ArrayToBlob, [
    pipe(prop('byteString'), bytesToUint8Array),
    pipe(prop('mimeType'), objOf('type')),
  ])
);

export const getOriginFileUrl = (channelId: CHANNEL_ID, fileId: FILE_ID, isShared: boolean) => {
  return isShared
    ? `${URLS.V4_API}/channels/${channelId}/files/${fileId}`
    : `${URLS.V2_API}/channel/${channelId}/file/${fileId}`;
};
